/* eslint-disable no-unused-vars */
import axios from "axios";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Form, Icon } from "semantic-ui-react";
import { Box3, Vector3 } from "three";
import { openMessage } from "../Modal";
import GLTFExporterExt from "../THREE_EXT/GLTFExporterExt";
import { wait } from "../Timeout";
import { USDZExporter } from "../UsdzExporterFile";
import { ModelContext, SettingsContext } from "../context";
import api from "../context/api";

import ModelVCheckbox from "./ModelVCheckbox";
import ProductImage from "./ProductImage";
import FileUpload from "./Upload";

const TURKISH_TO_ASCII = {
  ı: "i",
  İ: "i",
  i: "i",
  I: "i",
  ş: "s",
  Ş: "s",
  ç: "c",
  Ç: "c",
  ö: "o",
  Ö: "o",
  ü: "u",
  Ü: "u",
  ğ: "g",
  Ğ: "g",
};

function foldTurkishToAscii(text = "") {
  return text
    .toString()
    .replace(/[ıİiIşŞçÇöÖüÜğĞ]/g, (ch) => TURKISH_TO_ASCII[ch] || ch)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("en-US")
    .trim();
}

function normalizeCompanyName(text = "") {
  return foldTurkishToAscii(text).replace(/[^a-z0-9]/g, "");
}

function ProductInfo() {
  const {
    name,
    setName,
    company,
    setCompany,
    tagList,
    setTagList,
    getTags,
    getTagGroups,
    environment,
    tagGroupList,
    mapProduct,
    editorProductInfo,
    authenticationToken,
    setCategories,
    placeType,
    setPlaceType,
    setGlobalCategories,
    setGlobalCategoryList,
    selectedG_CategoryList,
    setSelectedG_CategoryList,
    selectedCategoryList,
    setSelectedCategoryList,
    globalCategoryList,
    productToUpdate,
    exportObj,
    id,
    companies,
    getCompanies,
    categoryList,
    setCategoryList,
    usePoster,
    useThumbnail,
    placeTypes,
    cameraOrbit,
    transmissionParams,
  } = useContext(SettingsContext);

  const { handleUsdz } = useContext(ModelContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [notification, setNotification] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedTagGroups, setSelectedTagGroups] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const tagInputRef = useRef(null);

  const exporter = new GLTFExporterExt();

  window.exporter = exporter;
  useEffect(() => {
    getTags();
    getTagGroups();
    getCompanies();
    getCategories();
    getTagsOfProduct();
    getGlobalCategories();
  }, [productToUpdate]);

  const getTagsOfProduct = async () => {
    if (id && id != "") {
      const responseTag = await api.getTagsByProductId(id);

      setSelectedTags(
        responseTag.data.map((tag) => {
          let label = tag.name + "-";
          label += tag.type;
          return { value: tag.id, label: label };
        })
      );
    }
  };

  const handleChangeplaceType = (e) => {
    setPlaceType(e);
  };

  const handleNewCategories = (e) => {
    let newC = [];
    e.map((category) => {
      newC.push(category);
    });

    setSelectedCategoryList(
      e.map((category) => {
        return { value: category.value, label: category.label };
      })
    );

    setCategories(
      e.map((category) => {
        return { id: category.value, name: category.label };
      })
    );
  };

  const handleNewGlobalCategories = (e) => {
    setSelectedG_CategoryList(
      e.map((category) => {
        return { value: category.value, label: category.label };
      })
    );
    setGlobalCategories(
      e.map((category) => {
        return { id: category.value, name: category.label };
      })
    );
  };

  const handleName = (inputName) => {
    setName(inputName);
  };

  const handleGlb = async () => {
    //downloadGlb
    let glb = await exportScene(true);
    downloadGlb(glb);
  };

  const handleGltf = async () => {
    let gltf = await exportScene(false);
    downloadGltf(gltf);
  };

  const handleFbx = async () => {
    let glb = await exportScene(true, false);
    let response = await api.convertGlbToFbx(glb);
    downloadFbx(response.data);
  };

  const downloadFbx = (data) => {
    const blob = new Blob([data], { type: "application/zip" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = editorProductInfo?.id
      ? editorProductInfo.id + ".zip"
      : "myFileName.zip";
    link.click();
  };

  const dataToBlob = (canvas) => {
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (data) => {
          resolve(data);
        },
        "image/png",
        1.0
      );
    });
  };

  const downloadGltf = (data) => {
    var text = JSON.stringify(data, null, 2);
    var filename = "gltfFileOfScene ";
    if (editorProductInfo?.id) filename = editorProductInfo?.id + "gltf";

    const link = document.createElement("a");
    link.href = URL.createObjectURL(
      new Blob([text], { type: "text/plain" }),
      filename
    );
    link.download = filename + ".gltf";
    link.click();
  };

  const downloadGlb = (data) => {
    const bytes = new Uint8Array(data);
    const blob = new Blob([bytes], { type: "application/glb" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "myFileName.glb";

    if (editorProductInfo?.id)
      link.download = editorProductInfo?.id + "glb.glb";
    link.click();
  };

  const getCategories = async () => {
    if (categoryList.length > 0) return;

    let res = await api.getCategories();
    const categoryListRes = res.data
      .map((category) => {
        let label = category.application.name + " - ";
        label += category.parentPath ? category.parentPath + " - " : "";
        label += category.name;
        return {
          value: category.id,
          label: label,
          companyId: category.application?.id,
          companyLabel: category.application?.name,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
    setCategoryList(categoryListRes);
  };

  const getGlobalCategories = async () => {
    if (globalCategoryList.length > 0) return;

    let res = await api.getGlobalCategories();
    const globalCategoryListRes = res.data.map((category) => {
      return {
        value: category.id,
        label: category.name,
      };
    });
    setGlobalCategoryList(globalCategoryListRes);
  };

  const testLinkGit = async () => {
    let productId = window.location.pathname.replace("/", "").toString();
    let testLinkUrl =
      "https://cdn.sugartech.io/ui/product/testLink/" + productId;

    if (productId == "") {
      alert("Ürünün Id'si bulunmamaktadır.");
      return;
    }
    window.open(testLinkUrl, "_blank").focus();
  };

  const calculateDimensions = () => {
    const modelViewer = document.getElementById("modelViewer");
    const scene = modelViewer?.scene();

    let boundingBox = new Box3().setFromObject(scene.modelContainer);
    const center = new Vector3();
    const size = new Vector3();
    boundingBox.getCenter(center);
    boundingBox.getSize(size);

    //setDimension({ xWidth: size.x, yHeight: size.y, zDepth: size.z });

    return size;
  };

  const sendProductToUpdate = async () => {
    openMessage("Bilgiler kontrol ediliyor");

    const modelViewer = document.getElementById("modelViewer");
    let scene = modelViewer?.scene();

    let productInfo = id ? await mapProduct() : editorProductInfo;
    console.log(environment);
    if (!environment) {
      openMessage("Lütfen Environment Imageyi boş bırakmayınız", true);
      return;
    }

    if (!name?.trim()) {
      openMessage("Lütfen Product Name'i boş bırakmayınız ", true);
      return;
    }

    if (!productInfo?.category?.length) {
      openMessage("Lütfen Kategori Seçiniz", true);
      return;
    }

    let glbFile = null;
    //Glb File Option
    if (exportObj[0].isSelected) {
      openMessage("Sahne export ediliyor, lütfen bekleyiniz.");

      glbFile = await exportScene(true);

      if (glbFile == null) {
        openMessage("Sahne export edilirken hata oluştu", true);
        return;
      }

      openMessage("Sahne export edildi");
    }

    openMessage("Ürün ölçüleri hesaplanıyor");

    const size = calculateDimensions();
    if (size) {
      productInfo.y = (size.y * 100).toFixed(2);
      productInfo.z = (size.z * 100).toFixed(2);
      productInfo.x = (size.x * 100).toFixed(2);
      openMessage(
        `Ürün ölçüleri hesaplandı: ${size.x} x ${size.y} x ${size.z}`
      );
      await wait(1000);
    }

    if (usePoster || useThumbnail) {
      modelViewer.cameraTarget = "0 0 0";
      if (productInfo.company.id == 2502) {
        modelViewer.cameraOrbit = "-25deg 70deg auto";
      } else {
        modelViewer.cameraOrbit = cameraOrbit;
      }
      await wait(1000);
    }

    productInfo.transmissionParams = transmissionParams;

    let thumbnailFile = null;
    if (useThumbnail) {
      let canvas = modelViewer.shadowRoot.querySelector("#webgl-canvas");
      thumbnailFile = await dataToBlob(canvas);
    }

    let posterFile = null;
    if (usePoster) {
      let canvas = modelViewer.shadowRoot.querySelector("#webgl-canvas");
      posterFile = await dataToBlob(canvas);
    }

    //USDZ Check
    let usdzFile = null;
    if (exportObj[1].isSelected) {
      usdzFile = await USDZExporter(scene);
    }

    try {
      const response = await api.saveProduct(
        productInfo,
        glbFile,
        thumbnailFile,
        posterFile,
        usdzFile
      );

      await api.updateTagsOfProduct(response.data.id, selectedTags);
      if (selectedTagGroups.length > 0) {
        await api.addTagGroupsToProduct(response.data.id, selectedTagGroups);
      }

      openMessage("Ürün Yüklendi...");
      setTimeout(() => {
        setModalOpen(false);
        setNotification(null);
        window.location.href = response.data?.id;
      }, 1000);
    } catch (e) {
      openMessage("Ürün Yükleme Sirasinda hata oluştu...", true);
    }
  };

  const duplicateProduct = async () => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "İşlem başlatıldı, lütfen bekleyiniz...",
      })
    );

    axios({
      method: "post",
      url: process.env.REACT_APP_BACKEND_API + "products/2/duplicate/" + id,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authenticationToken,
      },
    }).then(
      (res) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", { detail: "Ürün Kopyalandı." })
        );
        setTimeout(() => {
          setModalOpen(false);
          setNotification(null);
          window.location.href = res.data?.id;
        }, 1000);
      },
      (rej) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Ürün kopyalanırken hata oluştu.",
          })
        );

        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("close-editor-popup", { detail: "" })
          );
        }, 1000);
      }
    );
  };

  const addTag = async () => {
    await api.addTagToProduct(selectedTags, id);
  };
  const addTagGroup = async () => {
    await api.addTagGroupsToProduct(selectedTagGroups, id);
  };

  const deleteProduct = async () => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "İşlem başlatıldı, lütfen bekleyiniz...",
      })
    );

    axios({
      method: "post",
      url: process.env.REACT_APP_BACKEND_API + "products/2/delete/" + id,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authenticationToken,
      },
    }).then(
      (res) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", { detail: "Ürün Silindi." })
        );
        setTimeout(() => {
          setModalOpen(false);
          setNotification(null);
          window.location.href = res.data?.id;
        }, 1000);
      },
      (rej) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Ürün Silinirken hata oluştu.",
          })
        );

        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("close-editor-popup", { detail: "" })
          );
        }, 1000);
      }
    );
  };

  const exportScene = async (binary, compress = exportObj[3].isSelected) => {
    const modelViewer = document.getElementById("modelViewer");
    const scene = modelViewer?.scene();
    let modelContainer;
    scene.traverse((m) => {
      if (m.name == "ModelContainer") modelContainer = m;
    });

    return await exporter.parse(
      modelContainer,
      binary,
      compress
    );
  };

  const filterOption = (candidate, input) => {
    if (candidate.data.__isNew__) return true;
    const foldedInput = foldTurkishToAscii(input);
    if (!foldedInput) return true;
    return foldTurkishToAscii(candidate.label).includes(foldedInput);
  };

  const createTag = async (label) =>
    new Promise((resolve, reject) => {
      document.dispatchEvent(
        new CustomEvent("open-form-popup", {
          detail: {
            formFields: [
              {
                label: "Name",
                name: "name",
                type: "text",
                value: label,
              },
              {
                label: "Type",
                name: "type",
                type: "select",
                value: "MATERIAL",
                options: [
                  { value: "MATERIAL", label: "Material" },
                  { value: "ROOM", label: "Room" },
                  { value: "COLOR", label: "Color" },
                  { value: "STYLE", label: "Style" },
                  { value: "CUSTOM", label: "Custom" },
                ],
              },
            ],
            onSubmit: (async (data) => {
              console.log("creating tag", data);
              api.createNewTag(data).then((res) => {
                if (res.data.status == "error") {
                  reject(res.data.error);
                }
                resolve(res.data);
              });
            }).bind(this),
            onReject: ((err) => {
              resolve(null);
            }).bind(this),
          },
        })
      );
    });

  const handleCreateTag = async (inputValue) => {
    setIsLoading(true);
    createTag(inputValue)
      .then((newOption) => {
        setIsLoading(false);
        if (newOption) {
          setSelectedTags((prev) => [
            ...prev,
            {
              name: newOption.name,
              value: newOption.id,
              label: newOption.name + "-" + newOption.type,
            },
          ]);
        }
        document.dispatchEvent(new CustomEvent("close-form-popup"));
        tagInputRef.current.focus();
      })
      .catch((err) => {
        setIsLoading(false);
        document.dispatchEvent(new CustomEvent("close-form-popup"));
        document.dispatchEvent(
          new CustomEvent("open-editor-popup", { detail: "Error: " + err })
        );
        tagInputRef.current.focus();
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        }, 1000);
      });
  };

  const getModelViewer = () => {
    return document.getElementById("modelViewer");
  };

  const filteredCategoryOptions = useMemo(() => {
    const companyId = company?.value;
    const companyLabel = normalizeCompanyName(company?.label ?? "");
    if (!companyId && !companyLabel) return [];

    return categoryList.filter((category) => {
      const idMatches =
        companyId &&
        category.companyId &&
        String(category.companyId) === String(companyId);
      const categoryCompanyLabel = normalizeCompanyName(
        category.companyLabel ?? ""
      );
      const nameMatches =
        categoryCompanyLabel &&
        (categoryCompanyLabel === companyLabel ||
          categoryCompanyLabel.startsWith(companyLabel) ||
          companyLabel.startsWith(categoryCompanyLabel));

      return idMatches || nameMatches;
    });
  }, [categoryList, company?.label, company?.value]);

  function createJointedProduct() {
    const modelViewer = getModelViewer();
    const jointDefinition =
      modelViewer?.jointsportController.getJointDefinition();
    api
      .createJointedProduct(id, jointDefinition)
      .then((res) => res.data)
      .then((res) => (window.location.href = res))
      .catch((err) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: err,
          })
        );

        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("close-editor-popup", { detail: "" })
          );
        }, 1000);
      });
  }

  return (
    <div className="productInfo">
      <div>
        <Form>
          <Form.Field className="form-field">
            <label className="textArea" value={name} style={{ color: "white" }}>
              Product Name
            </label>
            <input
              value={name}
              onChange={(e) => handleName(e.target.value)}
              required
            />
          </Form.Field>
        </Form>
        <Form.Field className="form-field">
          <label className="textArea" style={{ color: "white" }}>
            Company
          </label>
          <Select
            menuPosition="fixed"
            isSearchable
            isClearable
            options={companies}
            selection
            value={company}
            placeholder="Select Company"
            filterOption={filterOption}
            onChange={(e) => {
              if (e?.value) setCompany(e);
            }}
          />{" "}
        </Form.Field>
        <div className="form-row">
          <div className="form-group">
            <label className="textArea">Category</label>
            <Select
              menuPosition="fixed"
              isSearchable
              isClearable
              isMulti
              options={filteredCategoryOptions}
              onChange={handleNewCategories}
              value={selectedCategoryList}
              placeholder="Select Category"
              filterOption={filterOption}
            />
          </div>

          <div className="form-group">
            <label className="textArea">Global Category</label>
            <Select
              menuPosition="fixed"
              isSearchable
              isClearable
              isMulti
              options={globalCategoryList}
              onChange={handleNewGlobalCategories}
              value={selectedG_CategoryList}
              placeholder="Select Global Category"
              filterOption={filterOption}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label className="textArea">Tags</label>
            <CreatableSelect
              isSearchable
              isClearable
              isDisabled={isLoading}
              isLoading={isLoading}
              isMulti
              options={tagList}
              placeholder="Select Tags"
              value={selectedTags}
              getOptionLabel={(option) => `${option.label}`}
              filterOption={filterOption}
              onCreateOption={handleCreateTag}
              onChange={setSelectedTags}
              ref={tagInputRef}
            />
          </div>
          <div className="form-group">
            <label className="textArea">Placement Type</label>
            <Select
              menuPosition="fixed"
              isClearable
              onChange={handleChangeplaceType}
              options={placeTypes}
              value={placeType}
              placeholder="Select Placement Type"
            />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <FileUpload />
          <div>
            <div>
              <div className="Checkbox" style={{ width: "100%" }}>
                <ModelVCheckbox />
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <FileUpload />
          <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
            {/* Kutucuk 2 - Update, Duplicate, Save With Joints, Delete */}
            <div
              style={{
                flex: 1,
                border: "1px solid gray",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              <div
                style={{ marginBottom: "10px", display: "flex", gap: "10px" }}
              >
                <button
                  className="saveButton"
                  onClick={() => sendProductToUpdate()}
                  style={{ flex: 1 }}
                >
                  <Icon name="lab" /> Update Product
                </button>
                <button
                  className="saveButton"
                  onClick={duplicateProduct}
                  style={{ flex: 1, backgroundColor: "blue" }}
                >
                  Duplicate Product
                </button>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  className="saveButton"
                  onClick={createJointedProduct}
                  style={{ flex: 1, backgroundColor: "gold", color: "black" }}
                >
                  Save With Joints
                </button>
                <button
                  className="saveButton"
                  onClick={deleteProduct}
                  style={{ flex: 1, backgroundColor: "red" }}
                >
                  Delete Product
                </button>
              </div>
            </div>
            <div
              style={{
                flex: 1,
                border: "1px solid gray",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              <div
                style={{ marginBottom: "10px", display: "flex", gap: "10px" }}
              >
                <button
                  onClick={handleUsdz}
                  className="editorButton"
                  style={{ flex: 1 }}
                >
                  <Icon name="download" /> Usdz
                </button>
                <button
                  onClick={handleGlb}
                  className="editorButton"
                  style={{ flex: 1 }}
                >
                  <Icon name="download" /> GLB
                </button>
                <button
                  onClick={handleFbx}
                  className="editorButton"
                  style={{ flex: 1 }}
                >
                  <Icon name="download" /> FBX
                </button>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={handleGltf}
                  className="editorButton"
                  style={{ flex: 1 }}
                >
                  <Icon name="download" /> GLTF
                </button>
                <button
                  onClick={testLinkGit}
                  className="editorButton"
                  style={{ flex: 1 }}
                >
                  <Icon name="lab" /> Test Link
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="productInfoLine" style={{ overflowY: "auto" }}>
          {id && (
            <div>
              <ProductImage />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default ProductInfo;
